import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { COLLEGE_RECON_CONSTANTS } from "../constants";

@Injectable()

export class FormatPhone {
    public phoneNumber(phone: any) {
        let cleaned = ('' + phone).replace(/\D/g, '');
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return null;
    }
}

export function toPhoneDigits(value: unknown): string {
  if (value == null) {
    return '';
  }
  return String(value).replace(/\D/g, '');
}

export function formatPhoneForSave(value: unknown): string {
  const digits = toPhoneDigits(value);
  const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : String(value ?? '');
}

export function phoneFormatValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const digits = toPhoneDigits(control.value);
  if (!digits) {
    return null;
  }
  return COLLEGE_RECON_CONSTANTS.phonePattern.test(digits)
    ? null
    : { invalidPhone: true };
}

export function isPhoneValid(value: unknown): boolean {
  if (value == null || String(value).trim() === '') {
    return false;
  }
  const digits = String(value).replace(/\D/g, '');
  return (
    digits.length === 10 &&
    COLLEGE_RECON_CONSTANTS.phonePattern.test(digits)
  );
}
